import Text from '@cartwhl/ui/base/TextNew';
import GoButton from '@cartwhl/ui/input/GoButton';

import type { PlatformFeature } from './pricingPageData';

interface PlatformCardProps {
  titlePrefix: string;
  titleSuffix: string;
  features: PlatformFeature[];
  onContactClick: () => void;
}

export default function PlatformCard({
  titlePrefix,
  titleSuffix,
  features,
  onContactClick,
}: PlatformCardProps) {
  const [primaryFeature, secondaryFeature] = features;

  return (
    <div className="flex flex-col gap-8 rounded-2xl border border-purple-50 bg-purple-50/10 px-6 py-7 lg:gap-14 lg:px-10 lg:py-10">
      <div className="flex flex-col gap-12">
        <Text
          as="h2"
          token={{ base: 'display/32/bold', lg: 'display/36/bold' }}
          className="text-pretty"
        >
          <span className="text-purple-60">{titlePrefix}</span> {titleSuffix}
        </Text>
        <GoButton
          variant="pose"
          className="w-full lg:w-[180px]"
          onClick={onContactClick}
        >
          Contact us
        </GoButton>
      </div>

      <div className="grid gap-10 border-purple-50/40 lg:grid-cols-2 lg:gap-14">
        <div className="flex flex-col gap-6 lg:gap-8">
          <Text as="h3" token="24/medium" className="text-pretty">
            {primaryFeature.title}
          </Text>
          <Text as="p" token="20/medium" className="text-secondary">
            {primaryFeature.body}
          </Text>
        </div>
        <div className="flex flex-col gap-6 lg:gap-8">
          <Text as="h3" token="24/medium" className="text-pretty">
            {secondaryFeature.title}
          </Text>
          <Text as="p" token="20/medium" className="text-secondary">
            {secondaryFeature.body}
          </Text>
        </div>
      </div>
    </div>
  );
}
